import React from 'react';
import { Route, Switch } from 'react-router-dom';
import ExportChats from '../../components/MainPage/modals/chatSettings/ExportChats';
import AutoDeleteSettings from '../../components/MainPage/modals/chatSettings/AutoDeleteSettings';
import ResolvePendingChats from '../../components/MainPage/modals/chatSettings/ResolvePendingChats/ResolvePendingChats';
import AutoResolveChats from '../../components/MainPage/modals/chatSettings/AutoResolveChats/AutoResolveChats';
const ChatSettingsRoute = () => {
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: "/manage/chats/export", component: ExportChats }),
        React.createElement(Route, { exact: true, path: "/manage/chats/auto-delete", component: AutoDeleteSettings }),
        React.createElement(Route, { exact: true, path: "/manage/chats/resolve-pending", component: ResolvePendingChats }),
        React.createElement(Route, { exact: true, path: "/manage/chats/auto-resolve", component: AutoResolveChats })));
};
export default ChatSettingsRoute;
